import { productChangeOfAddressInitialState } from "./productChangeOfAddress";
import { PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_STATE } from "./constants";

const clear = (state: any) => {
	Object.assign(state, productChangeOfAddressInitialState());
};

const SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS = (state: any, payload: any) => {
	const { coverage } = payload;

	state.changeOfAddress = {
		...state.changeOfAddress,
		coverage,
		notes: payload?.notes ?? "",
		intermediateProduct: {
			...state.changeOfAddress.intermediateProduct,
			salesPerson: payload?.intermediateProduct?.salesPerson ?? "",
			targetDate: payload?.intermediateProduct?.targetDate ?? ""
		}
	};
};

const SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_ID = (state: any, payload: any) => {
	state.id = payload;
};

const SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_STATUS = (state: any, payload: string) => {
	state.status = payload;
};

const SET_PRODUCT_CHANGE_OF_ADDRESS_SHOPPING_CART_ID = (state: any, payload) => {
	state.shoppingCartId = payload;
};

const SET_ORDER_CHANGE_OF_ADDRESS = (state: any, payload: any) => {
	state.changeOfAddress = {
		...state.changeOfAddress,
		intermediateProduct: {
			...state.changeOfAddress.intermediateProduct,
			salesPerson: payload?.salesPerson ?? state.changeOfAddress.intermediateProduct.salesPerson,
			targetDate: payload?.targetDate ?? state.changeOfAddress.intermediateProduct.targetDate
		},
		notes: payload?.notes ?? state.changeOfAddress.notes
	};
};

export default {
	[PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_STATE]: clear,
	SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS,
	SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_ID,
	SET_PRODUCT_CHANGE_OF_ADDRESS_PROCESS_STATUS,
	SET_PRODUCT_CHANGE_OF_ADDRESS_SHOPPING_CART_ID,
	SET_ORDER_CHANGE_OF_ADDRESS
};
